/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Empty1Inputs */

const zh_adminsubs_empty1 = /** @type {(inputs: Adminsubs_Empty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无订阅记录`)
};

const en_adminsubs_empty1 = /** @type {(inputs: Adminsubs_Empty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No subscription records`)
};

const es_adminsubs_empty1 = /** @type {(inputs: Adminsubs_Empty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin registros de suscripción`)
};

/**
* | output |
* | --- |
* | "No subscription records" |
*
* @param {Adminsubs_Empty1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_empty1 = /** @type {((inputs?: Adminsubs_Empty1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Empty1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_empty1(inputs)
	if (locale === "en") return en_adminsubs_empty1(inputs)
	return es_adminsubs_empty1(inputs)
});
export { adminsubs_empty1 as "adminSubs_empty" }